import clsx from "clsx";
import { Link } from "@remix-run/react";
import { type FunctionComponent } from "react";
import { buttonBase } from "../Common/FormStyle";
import aboutBg from "../../assets/about_bg.jpg";

interface TopWhatProps {}

const TopWhat: FunctionComponent<
  TopWhatProps
> = () => {
  return (
    <div
      className={clsx(
        "text-center",
        "bg-cover",
        "py-70",
      )}
      style={{
        backgroundImage: `url(${aboutBg})`,
      }}
    >
      <h2
        className={clsx(
          "text-40",
          "font-bold",
          "max-md:text-32",
        )}
      >
        What is OURPR?
      </h2>
      <p
        className={clsx(
          "w-600",
          "mx-auto",
          "mt-20",
          "max-md:w-330",
          "leading-[1.75]",
        )}
      >
        OURPRは、「より気軽に、より自由にPRできる」プラットフォームです。従来のプレスリリースのようにニュース性にしばれることなく、日々の取り組みや小さな喜びを、スタンプやフォローを通じて共感と応援の輪へ広げていきます。また、企業・団体・個人のページを充実させており、自らの“ストーリー”を発信し、積み重ねていくことで、PRが「プロフィール」として育つ新しい場を目指しています。
      </p>
      <div className={clsx("mt-32")}>
        <Link
          to="/create-account"
          className={clsx(buttonBase())}
        >
          登録希望の方はこちら
        </Link>
      </div>
    </div>
  );
};

export default TopWhat;
